<template>
    <div class="container">
        <container :active_path="path" :plate="'云招商'">
            <div class="base-warp">
                <div class="head">
                    <el-form :model="form" ref="form" label-width="80px" :inline="true" size="normal">
                        <el-form-item label="姓名">
                            <el-input v-model="form.name" size="mini"></el-input>
                        </el-form-item>
                        <el-form-item label="电话">
                            <el-input v-model="form.telephone" size="mini"></el-input>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="form.status" placeholder="状态" size="mini">
                                <el-option :label="item.label" :value="item.value" v-for="(item, index) in status" :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="mini" type="primary" @click="confirm">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>

                <div class="table-box">
                    <el-table :data="tableData" 
                    border 
                    stripe
                    @row-click="getrow"
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column label="序号" type="index" width="60"></el-table-column>
                        <el-table-column prop="name" label="姓名" align="center"></el-table-column>
                        <el-table-column prop="telephone" label="电话" align="center"></el-table-column>
                        <el-table-column prop="idcard" label="身份证" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="" label="营业执照" align="center">
                            <template slot-scope="scope">
                                <p class="status text-success" v-if="scope.row.businessLicense">已添加</p>
                                <p class="status text-danger" v-else>未添加</p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="工作证" align="center">
                            <template slot-scope="scope">
                                <p class="status text-success" v-if="scope.row.workPermit">已添加</p>
                                <p class="status text-danger" v-else>未添加</p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="头像" align="center">
                            <template slot-scope="scope">
                                <p class="status text-success" v-if="scope.row.ltpic">已添加</p>
                                <p class="status text-danger" v-else>未添加</p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="status" label="状态" align="center">
                            <template slot-scope="scope">
                                <p class="status text-warning" v-if="scope.row.status=='01'">待审核</p>
                                <p class="status text-success" v-if="scope.row.status=='03'">已通过</p>
                                <p class="status text-danger" v-if="scope.row.status=='04'">不通过</p>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
            </div>
        </container>
        <router-view></router-view>
    </div>
</template>

<script>
import container from "../../../components/container"
export default {
    components: {
        container,
    },
    data() {
        return {
            path: '/attract/user',
            form: {
                name: '',
                telephone: '',
                status: '',
            },
            status: [
                {
                    label: '全部',
                },
                {
                    label: '待审核',
                    value: '01',
                },
                {
                    label: '已通过',
                    value: '03',
                },
                {
                    label: '不通过',
                    value: '04',
                },
            ],
            tableData: [],
            total: 0,
            pageNo: 1,
            pagesize: 14,
        }
    },
    mounted () {
        this.getData();
    },
    methods: {
        confirm() {
            this.pageNo = 1;
            this.getData();
        },
        getrow(row) {
            var item = JSON.stringify(row);
            this.$router.push({path: '/attract/user/detail', query: {item}});
        },
        getData() {
            var params = {
                name: this.form.name,
                telephone: this.form.telephone,
                status: this.form.status,
                pageNo: this.pageNo,
                pagesize: this.pagesize,
            };
            this.$api.getBrokers(params).then(
                data=>{
                    console.log(data);
                    let {list, total} = data;
                    this.total = total;
                    this.tableData = list;
                }
            )
        },
        currentChange(page) {
            this.pageNo = page;
            this.getData();
        },
    },
    beforeRouteUpdate(to, from, next) {
        if (from.path == "/attract/user/detail"){
            this.getData();
        }
        next();
    },
}
</script>

<style lang="scss" scoped>

</style>